
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

interface IconInfoProps {
  icon: string;
  id?: string;
}

class IconInfo extends React.Component<IconInfoProps, {}> {

  render() {

    let statusId: string;
    let icon: string;
    switch (this.props.icon) {
      case 'search':
        statusId = 'Status.Search';
        icon = '/img/icon-search.svg';
        break;
      case 'closed':
        statusId = 'Status.Closed';
        icon = '/img/icon-complete.svg';
        break;
      case 'canceled':
        statusId = 'Status.Canceled';
        icon = '/img/icon-cancel.svg';
        break;
      case 'notfound':
        statusId = 'Status.NotFound';
        icon = '/img/icon-warning.svg';
        break;
      default:
        statusId = 'Status.Error';
        icon = '/img/icon-warning.svg';
    }

    let styles = {
      host: {
        background: '#FAFAFA',
        padding: '2px',
        display: 'flex',
        flex: '1 0 auto',
        alignItems: 'center' as 'center',
        boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.25)',        
        zIndex: 1000
      },
      container: {
        display: 'flex',
        alignItems: 'center' as 'center',
      },
      message: {
        fontSize: '24px',
        fontWeight: 'bold' as 'bold',
        textAlign: 'center',
        padding: '0 1em'
      },
      icon: {
        padding: '1em',
        height: '74px',
        width: '74px'
      }
    };

    return (
      <div id={this.props.id} style={styles.host}>
        <div className="container" style={styles.container}>
          <img src={icon} style={styles.icon}/>
          <div className="status-msg" style={styles.message}>
            <FormattedMessage id={statusId} />
          </div>
        </div>
      </div>
    );
  }
}

export default IconInfo;



// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/IconInfo.tsx